import './map/style.css';

import { useState, useEffect, useRef, useMemo } from 'react';
import { Map, APIProvider, useMap } from '@vis.gl/react-google-maps';
import { MarkerClusterer } from '@googlemaps/markerclusterer';

import { CustomAdvancedMarker } from './map/components/custom-advanced-marker/custom-advanced-marker';

// Ana bileşen - APIProvider wrapper
const ProductListOnMap = ({ activities }: { activities: any[] }) => {
  return (
    <APIProvider apiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY as string}>
      <MapWithClustering activities={activities} />
    </APIProvider>
  );
};

// Clustering mantığını içeren bileşen
function MapWithClustering({ activities }: { activities: any[] }) {
  const map = useMap();
  const [openMarkerId, setOpenMarkerId] = useState<string | null>(null);
  const [markersLoaded, setMarkersLoaded] = useState(0);
  const clustererRef = useRef<MarkerClusterer | null>(null);
  const markersRef = useRef<google.maps.marker.AdvancedMarkerElement[]>([]);

  // Geçerli koordinatlara sahip aktiviteleri filtrele
  const validActivities = useMemo(() => {
    return (
      activities?.filter((activity) => {
        const lat = Number(activity.location?.lat);
        const lng = Number(activity.location?.long);
        return (
          !isNaN(lat) &&
          !isNaN(lng) &&
          lat !== 0 &&
          lng !== 0 &&
          lat >= -90 &&
          lat <= 90 &&
          lng >= -180 &&
          lng <= 180
        );
      }) || []
    );
  }, [activities]);

  // Markerlar değiştiğinde state'i sıfırla
  useEffect(() => {
    setMarkersLoaded(0);
    markersRef.current = [];
  }, [validActivities]);

  // Clustering'i yönet - tüm markerlar yüklendiğinde
  useEffect(() => {
    if (!map || markersLoaded !== validActivities.length || validActivities.length === 0) return;

    // Geçerli markerları filtrele
    const validMarkers = markersRef.current.filter(Boolean);
    
    if (validMarkers.length === 0) return;

    // Mevcut clusterer'ı temizle
    if (clustererRef.current) {
      clustererRef.current.clearMarkers();
    }

    // Yeni clusterer oluştur
    const clusterer = new MarkerClusterer({
      map,
      markers: validMarkers,
      algorithmOptions: {
        maxZoom: 15, // Bu zoom seviyesinden sonra cluster açılır
      },
    });

    clustererRef.current = clusterer;

    return () => {
      if (clustererRef.current) {
        clustererRef.current.clearMarkers();
        clustererRef.current = null;
      }
    };
  }, [map, markersLoaded, validActivities.length]);

  // Marker yüklendiğinde kaydet ve counter'ı artır
  const handleMarkerLoad = (index: number) => (marker: google.maps.marker.AdvancedMarkerElement) => {
    markersRef.current[index] = marker;
    setMarkersLoaded((prev) => prev + 1);
  };

  return (
    <div className="advanced-marker-example">
      <Map
        mapId={process.env.REACT_APP_GOOGLE_MAPS_ID as string}
        style={{ width: '100%', height: '100vh' }}
        defaultCenter={{ lat: 41.0082, lng: 28.9784 }}
        defaultZoom={10}
        gestureHandling="greedy"
        disableDefaultUI
        onClick={() => setOpenMarkerId(null)}
      >
        {validActivities.map((activity: any, index: number) => (
          <CustomAdvancedMarker
            key={activity._id || activity.id}
            activity={activity}
            openMarkerId={openMarkerId}
            setOpenMarkerId={setOpenMarkerId}
            onMarkerLoad={handleMarkerLoad(index)}
          />
        ))}
      </Map>
    </div>
  );
}

export default ProductListOnMap;
